import { getMonth } from "./get-month";

/**
 * Format a birthday date as "DD Month YYYY"
 */
export function formatBirthdayString(birthday: Date): string {
  return `${birthday.getDate()} ${getMonth(birthday)} ${birthday.getFullYear()}`;
}

/**
 * Calculate age from a birthday date
 */
export function calculateAge(birthday: Date): number {
  const today = new Date();
  let age = today.getFullYear() - birthday.getFullYear();
  const monthDiff = today.getMonth() - birthday.getMonth();

  // Adjust age if birthday hasn't occurred yet this year
  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getDate() < birthday.getDate())
  ) {
    age--;
  }

  return age;
}
